import type { BlobLike } from "@pdfking/compatibility"
import type { PdfiumApi, PdfiumTypeMap, Pointer } from "@pdfking/pdfium-wrap"
import type { Bytes } from "@pdfking/tfunc"
import { BlobArray } from "@pdfking/compatibility"
import { PdfiumExports as E } from "@pdfking/pdfium-wrap"
import { Channel } from "@pdfking/tfunc"

type PointerDoc = PdfiumTypeMap["FPDF_DOCUMENT"]

export const SaveDocument = (
  { addCallback, malloc, readBytes, safeCall, setInt32 }: PdfiumApi,
  doc_pointer: PointerDoc
): AsyncGenerator<BlobLike> => {
  const { push, stop, stream } = Channel<BlobLike>()

  const write_callback = (_: number, data: number, size: number) => {
    push(BlobArray(readBytes(data as Pointer, size as Bytes)))
    return size
  }

  const runner = async () => {
    const { free: freeCallback, pointer: callbackPtr } = addCallback(
      write_callback,
      "iiii"
    )
    const { free: freeStruct, pointer: structPtr } = malloc(8 as Bytes)

    setInt32(structPtr, 1)
    setInt32((structPtr + 4) as Pointer, callbackPtr)

    try {
      await safeCall(E.FPDF_SaveAsCopy, doc_pointer, structPtr, 2)
      stop(undefined)
    } catch (e) {
      stop(e as Error)
    } finally {
      freeStruct()
      freeCallback()
    }
  }

  void runner()

  return stream
}
